import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "contact-conversations__list"
}
const _hoisted_2 = { class: "contact-conversations__list-item" }
const _hoisted_3 = {
  key: 2,
  class: "contact-conversations__empty"
}

import { Conversation } from '../models/conversation';
import ContactConversation from './ContactConversation.vue';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactConversationList',
  props: {
  conversations: {
    type: Array as PropType<Conversation[]>,
    default: [],
  },
  workspaceId: {
    type: String,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_n_loading_spinner = _resolveComponent("n-loading-spinner")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["contact-conversations", { 'contact-conversations--has-one': __props.conversations.length === 1 }])
  }, [
    (__props.loading)
      ? (_openBlock(), _createBlock(_component_n_loading_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    (!__props.loading && __props.conversations.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.conversations, (conversation, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "contact-conversations__list-item-container",
              key: conversation.id
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(ContactConversation, {
                  conversation: conversation,
                  workspaceId: __props.workspaceId,
                  expanded: index === 0,
                  class: _normalizeClass({ 'contact-conversation--fill-height': __props.conversations.length === 1 })
                }, null, 8, ["conversation", "workspaceId", "expanded", "class"])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!__props.loading && __props.conversations.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "No conversations found"))
      : _createCommentVNode("", true)
  ], 2))
}
}

})